var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-system-bar',[_vm._v("Lehrpersonen-Flipper")]),_c('v-card-text',[_c('Flipper',{attrs:{"value":_vm.filteredTeachers,"name":`flipper_teachers_d${_vm.filterDivision}_fs${_vm.filterDepartment}_stvs${_vm.filterStvs}_new${_vm.filterNew}`}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }